import {
  Box,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import ButtonComp from "../../../../../components/Button";
import Input from "../../../../../components/Input";
import { usePersonalInfoFormStore } from "../../../../../store/usePersonalInfoFormStore";
import { string } from "../../../../../constants/string";
import {
  isValidContactNumber,
  isValidEmail,
} from "../../../../../utils/validators";
import { usePolicyStore } from "../../../../../store/usePolicyStore";

export default function PersonalInformation({
  handleBack,
  handleTenPercentPolicyInfoNext,
}: any) {
  const [showErrors, setShowErrors] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({
    email: "",
    contactNumber: "",
    identificationNumber: "",
    title: "",
    firstName: "",
    lastName: "",
    address: "",
    identificationType: "",
    initials: "",
    gender: "",
    dateOfBirth: "",
    agentOrBroker: "",
    sourceOfFunds: "",
    preferredLanguage: "",
    preferredMethodOfCommunication: "",
    nationality: "",
    idExpiryDate: "",
    claimantIdFile: "",
    relationship: "",
    networkProvider: "",
  });

  const personalInfoForm = usePersonalInfoFormStore(
    (state) => state.personalInfoForm
  );
  const setPersonalInfoForm = usePersonalInfoFormStore(
    (state) => state.setPersonalInfoForm
  );
  const policyData = usePolicyStore((state) => state.policyData);

  const handleTenPercentChange = (field: string, value: string) => {
    const updated = { ...personalInfoForm, [field]: value };
    setPersonalInfoForm(updated);

    if (!showErrors) return;

    setErrors((prev) => {
      const newErrors = { ...prev };

      const isString = typeof value === "string";
      const trimmed = isString ? value.trim() : "";

      if (!trimmed && isString) {
        newErrors[field] = `Please enter ${field
          .replace(/([A-Z])/g, " $1")
          .toLowerCase()}`;
      } else if (isString) {
        newErrors[field] = "";
      }

      if (field === "email" && isString) {
        newErrors.email = !trimmed
          ? "Please enter email"
          : isValidEmail(trimmed)
          ? ""
          : "Invalid email address";
      }

      if (field === "contactNumber" && isString) {
        newErrors.contactNumber = !trimmed
          ? "Please enter contact number"
          : isValidContactNumber(trimmed)
          ? ""
          : "Invalid contact number (10 digits only)";
      }

      if (field === "dateOfBirth" && isString) {
        const isValidDate = !isNaN(Date.parse(trimmed));
        newErrors.dateOfBirth = !trimmed
          ? "Please enter date of birth"
          : isValidDate
          ? ""
          : "Invalid date format";
      }

      if (field === "claimantIdFile") {
        newErrors.claimantIdFile = value
          ? ""
          : "Please upload ID or Passport copy";
      }

      return newErrors;
    });
  };

  console.log(personalInfoForm,"personal form>>>>>")

  const validateTenPercentForm = () => {
    const newErrors = {
      firstName: "",
      lastName: "",
      address: "",
      contactNumber: "",
      email: "",
      identificationNumber: "",
      policyNumber: "",
      identificationType: "",
    };

    let isValid = true;

    if (!personalInfoForm.firstName) {
      newErrors.firstName = "Please enter first name";
      isValid = false;
    }

    if (!personalInfoForm.lastName) {
      newErrors.lastName = "Please enter last name";
      isValid = false;
    }

    if (!personalInfoForm.address) {
      newErrors.address = "Please enter address";
      isValid = false;
    }

    if (!personalInfoForm.email) {
      newErrors.email = "Please enter email";
      isValid = false;
    } else if (!isValidEmail(personalInfoForm.email)) {
      newErrors.email = "Invalid email address";
      isValid = false;
    }

    if (!personalInfoForm.contactNumber) {
      newErrors.contactNumber = "Please enter contact number";
      isValid = false;
    } else if (!isValidContactNumber(personalInfoForm.contactNumber)) {
      newErrors.contactNumber = "Invalid contact number (10 digits only)";
      isValid = false;
    }

    if (!personalInfoForm.identificationNumber) {
      newErrors.identificationNumber = "Please enter identification number";
      isValid = false;
    }

    if (!personalInfoForm.identificationType) {
      newErrors.identificationType = "Please select identification type";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const handleNext = () => {
    setShowErrors(true);
    if (validateTenPercentForm()) {
      handleTenPercentPolicyInfoNext?.(personalInfoForm);
    }
  };

  useEffect(() => {
      if (policyData?.policy_number) {
        if (policyData?.policy_number) {
          setPersonalInfoForm({ policyNumber: policyData.policy_number });
        }
      }
    }, [policyData]);

  return (
    <Box component="form" noValidate autoComplete="off">
      <Box sx={{ px: { xs: 2 }, py: 4 }}>
        <Grid container spacing={2}>
          <Grid size={6}>
            <Input
              fullWidth
              label="First Name"
              value={personalInfoForm.firstName}
              onChange={(e: any) =>
                handleTenPercentChange("firstName", e.target.value)
              }
              error={showErrors && Boolean(errors.firstName)}
              helperText={showErrors ? errors.firstName : ""}
            />
          </Grid>

          <Grid size={6}>
            <Input
              fullWidth
              label="Last Name"
              value={personalInfoForm.lastName}
              onChange={(e: any) =>
                handleTenPercentChange("lastName", e.target.value)
              }
              error={showErrors && Boolean(errors.lastName)}
              helperText={showErrors ? errors.lastName : ""}
            />
          </Grid>

          <Grid size={4}>
            <Input
              fullWidth
              label="Address"
              value={personalInfoForm.address}
              onChange={(e: any) =>
                handleTenPercentChange("address", e.target.value)
              }
              error={showErrors && Boolean(errors.address)}
              helperText={showErrors ? errors.address : ""}
            />
          </Grid>
          <Grid size={4}>
            <Input
              fullWidth
              type="number"
              label="Contact Number*"
              value={personalInfoForm.contactNumber}
              onChange={(e: any) =>
                handleTenPercentChange("contactNumber", e.target.value)
              }
              error={showErrors && Boolean(errors.contactNumber)}
              helperText={showErrors ? errors.contactNumber : ""}
            />
          </Grid>
          <Grid size={4}>
            <Input
              fullWidth
              label="Email"
              value={personalInfoForm.email}
              onChange={(e: any) =>
                handleTenPercentChange("email", e.target.value)
              }
              error={showErrors && Boolean(errors.email)}
              helperText={showErrors ? errors.email : ""}
            />
          </Grid>

          <Grid size={6}>
            <Input
              fullWidth
              label="Identification Number"
              value={personalInfoForm.identificationNumber}
              onChange={(e: any) =>
                handleTenPercentChange("identificationNumber", e.target.value)
              }
              error={showErrors && Boolean(errors.identificationNumber)}
              helperText={showErrors ? errors.identificationNumber : ""}
            />
          </Grid>
          <Grid size={6}>
            <Input
              disabled
              fullWidth
              label="Policy number"
              value={policyData?.policy_number}
              backgroundColor="background.paper"
              error={showErrors && Boolean(errors.policyNumber)}
              helperText={showErrors ? errors.policyNumber : ""}
            />
          </Grid>

          <Grid size={12}>
            <Typography
              variant="h5"
              sx={{ mb: 1, textAlign: "left", fontWeight: 600 }}
            >
              Identification Type*
            </Typography>
            <RadioGroup
              row
              value={personalInfoForm.identificationType}
              onChange={(e) =>
                handleTenPercentChange("identificationType", e.target.value)
              }
            >
              <FormControlLabel
                value="ID"
                control={<Radio />}
                label="South Africa National ID"
              />
              <FormControlLabel
                value="passport"
                control={<Radio />}
                label="Passport"
              />
            </RadioGroup>
            {showErrors && errors.identificationType && (
              <Typography
                color="error"
                variant="body2"
                sx={{ textAlign: "left" }}
              >
                {errors.identificationType}
              </Typography>
            )}
          </Grid>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              py: 6,
            }}
          >
            <ButtonComp
              variant="outlined"
              height={40}
              fontSize="16px"
              width={200}
              onClick={handleBack}
            >
              {string.claims.back}
            </ButtonComp>
            <ButtonComp
              variant="contained"
              height={40}
              fontSize="16px"
              width={200}
              onClick={handleNext}
            >
              {string.claims.next}
            </ButtonComp>
          </Box>
        </Grid>
      </Box>
    </Box>
  );
}
